import { SEARCH_ENGINE_DESCRIPTION_LIMIT } from "@/config/constants";

// Formats a date string from "2024-10-28" to "October 28, 2024" format
export function formatDate(inputDate: string) {
  const dated = new Date(inputDate);
  const formatted = new Intl.DateTimeFormat("en-US", { year: "numeric", month: "long", day: "numeric" }).format(dated);

  return formatted;
}

// Converts duration (3.0345) to mm:ss format
export function formatDuration(duration: number, variant: "digital" | "basic" | "detailed" = "digital") {
  duration = Math.round(duration);

  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;

  if (variant === "digital") {
    const paddedMinutes = String(minutes).padStart(2, "0");
    const paddedSeconds = String(seconds).padStart(2, "0");

    return `${paddedMinutes}:${paddedSeconds}`;
  } else if (variant === "basic") {
    const formattedHours = hours > 0 ? `${hours}h` : "";
    const formattedMinutes = minutes > 0 ? `${minutes}m` : "";

    return `${formattedHours} ${formattedMinutes}`.trim(); // "1h 29m" format
  } else if (variant === "detailed") {
    const formattedHours = hours > 0 ? `${hours} ${hours === 1 ? "hour" : "hours"}` : "";
    const formattedMinutes = minutes > 0 ? `${minutes} ${minutes === 1 ? "minute" : "minutes"} ` : "";

    return `${formattedHours} ${formattedMinutes}`.trim(); // "1 hour 29 minutes" format
  }
}

export function formatDurationCustom(duration: number) {
  duration = Math.round(duration);

  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;

  return { hours, minutes, seconds };
}

// Formats a price number from "2500" to "Rs 2,500" format
export function formatPrice(price: number) {
  const formatted = new Intl.NumberFormat("en-PK", {
    style: "currency",
    currency: "PKR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);

  return formatted;
}

// Converts size "125443" to readable format
export function formatSize(bytes: number, decimals = 2) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

// Strip markdown and truncate text for metadata
export function formatSearchEngineDescription(text: string) {
  if (text.length <= SEARCH_ENGINE_DESCRIPTION_LIMIT) {
    return text;
  }

  // find the last space before maxLength
  const truncated = text.slice(0, SEARCH_ENGINE_DESCRIPTION_LIMIT);

  return truncated.slice(0, truncated.lastIndexOf(" ")) + "...";
}

export function formatUserFullName(firstName?: string | null, lastName?: string | null) {
  return [firstName, lastName].filter(Boolean).join(" ");
}
